import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import CheckboxFilter from 'bundles/backoffice/filters/checkbox';

import './styles.scss';

export const statusOptions = [
  { className: 'checkbox-critical-date', label: 'Critical Date', value: 'criticalDate' },
  { className: 'checkbox-completed', label: 'Completed', value: 'completed' },
  { className: 'checkbox-overdue', label: 'Overdue', value: 'overdue' },
  { className: 'checkbox-open', label: 'Open', value: 'open' },
];

export default function PlannerStatusFilters({ plannerFilters, setAllStatuses, setStatus }) {
  const allOption = { className: 'checkbox-all', label: 'All', value: 'all' };
  const statuses = useMemo(() => {
    const selected = [];

    statusOptions.forEach((filter) => {
      if (plannerFilters[filter.value]) {
        selected.push(filter.value);
      }
    });

    if (selected.length === statusOptions.length) {
      selected.push(allOption.value);
    }

    return selected;
  }, [plannerFilters]);

  const setFilter = (filter, value) => {
    if (filter === allOption.value) {
      setAllStatuses(value);
    } else {
      setStatus(filter, value);
    }
  };

  return (
    <CheckboxFilter
      addFilter={(_name, filter) => setFilter(filter, true)}
      filterTag={statuses.find(status => status === allOption.value) ? allOption.label : null}
      hideClearControl={statuses.length === 0}
      hideSelectedCount={statuses.length === 0}
      label="Status"
      name="planner-filter-statuses"
      options={[allOption, ...statusOptions]}
      removeFilter={(_name, filter) => setFilter(filter, false)}
      selected={statuses}
    />
  );
}

PlannerStatusFilters.propTypes = {
  plannerFilters: PropTypes.object.isRequired,
  setAllStatuses: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
};
